import "./LabAdminDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import {CommonService} from "../../../../../shared/services";
import React from "react";

interface LabAdminDetailsViewComponentProps {
    labAdminDetails: any;
    onEditModeOpen: any;
    canEdit: boolean;
}

const LabAdminDetailsViewComponent = (props: LabAdminDetailsViewComponentProps) => {
    const {labAdminDetails, onEditModeOpen,canEdit} = props;

    return (
        <div className={'admin-details-view-component details-tab-data-content'}>
            <div className="details-tab-data-header">
                <div className="view-and-edit-title">Basic Details</div>
                {canEdit && <div className={'edit-action-button'}>
                    <ButtonComponent
                        className={"white-space-nowrap"}
                        type="button"
                        color={"primary"}
                        variant={"outlined"}
                        startIcon={<EditIcon/>}
                        fullWidth={true}
                        handleClick={onEditModeOpen}
                    >
                        Edit Details
                    </ButtonComponent>
                </div>
                }
            </div>
            <div className="details-tab-data-body">
                <Grid container spacing={2} className="pdd-top-0">
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"NPI Number"}> {labAdminDetails?.npiNumber || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Middle Name"}> {labAdminDetails?.middleName || 'N/A'} </DetailsDataKeyValueComponent>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"First Name"}> {labAdminDetails?.firstName || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Last Name"}> {labAdminDetails?.lastName || 'N/A'} </DetailsDataKeyValueComponent>

                    </Grid>
                </Grid>
            </div>
            <div className="horizontal-line"/>
            <>
                <div className="view-and-edit-title">Contact Details</div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Email ID"}> {labAdminDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Fax Number"}> {CommonService.getMaskedMobileNumber(labAdminDetails?.faxNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Mobile Number"}> {labAdminDetails?.mobileNumber ? CommonService.getMaskedMobileNumber(labAdminDetails?.mobileNumber) : 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>

                    </Grid>
                </div>
            </>
            <div className="horizontal-line"/>
            <div className="view-and-edit-title">Address Details</div>
            <div className="details-tab-data-body">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Address Line 1"}> {labAdminDetails?.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"ZIP Code"}> {labAdminDetails?.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"City"}> {labAdminDetails?.city || 'N/A'} </DetailsDataKeyValueComponent>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Address Line 2"}> {labAdminDetails?.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"State"}> {labAdminDetails?.state || 'N/A'} </DetailsDataKeyValueComponent>

                    </Grid>
                </Grid>
            </div>
        </div>
    );

};

export default LabAdminDetailsViewComponent;
